import { VFC } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormDatepickerField } from "../../../../../../shared/components/form/fields/form-datepicker.field";
import { FormField } from "../../../../../../shared/components/form/form-field.component";
import { ICfmResponseValueFormInputs } from "../../actions/order-x-action.component";

export const OrderXLogisticAnnouncedSingleOrderBulkAction: VFC = () => {
  const {
    formState: { errors },
    control,
  } = useFormContext<ICfmResponseValueFormInputs>();
  const { t } = useTranslation();

  return (
    <FormField md={12} className={"pb-4"}>
      <FormDatepickerField
        name="logisticAnnounced.plannedPickupDate"
        label={t(`orders.accept_form.planned_pickup_date.label`)}
        hasError={Boolean(errors?.logisticAnnounced?.plannedPickupDate)}
        control={control}
        required={true}
      />
    </FormField>
  );
};
